export default __webpack_public_path__ + "static/media/hero.569bf84b.svg";